<template>
    <div class="fill-height text-grey-darken-1">
        <v-dialog v-model="showDialog" content-class="w-auto bg-white rounded-xl h-100 z-100">
            <div class="overflow-y-scroll">
                <div class="d-flex justify-space-between ga-4 mb-n12 z-100 position-relative">
                    <v-spacer></v-spacer>
                    <v-btn
                        :icon="mdiClose"
                        variant="plain"
                        size="x-small"
                        class="text-body-1 ma-4"
                        color="grey-lighten-1"
                        @click="showDialog = false"
                    >
                    </v-btn>
                </div>
                <product v-bind="quickProduct"></product>
            </div>
        </v-dialog>
        <v-hover
            v-if="variant === 'box'"
            v-slot="{ isHovering, props }"
        >
            <v-card
                class="product-card fill-height d-flex flex-column rounded-0"
                :class="{'modal-slider': modalSlider, 'opacity-70 cursor-not-allowed': product.state && product.state !== 'active'}"
                :elevation="isHovering ? 2 : 0"
                :ripple="false"
                v-bind:class="cssClass"
                v-bind="props"
                @click="router.visit(product.url + (query ? '?trackquery=' + query : ''), {onStart: handleLink})"
            >
                <v-card-text
                    class="text-body-1 fill-height"
                    :class="{'px-4': modalSlider}"
                >
                    <div class="d-flex justify-space-between">
                        <Link :href="(actualProductVariant?.url || product.url) + (query ? '?trackquery=' + query : '')"
                              class="product-name font-weight-black mb-1"
                              :class="[{'modal-slider': modalSlider}, modalSlider ? '' : 'text-body-2 text-md-body-1']"
                              :onStart="handleLink">
                            {{ product.name }}
                        </Link>
                        <slot name="actionsTop"></slot>
                    </div>
                    <div class="position-relative mt-4">
                        <tag :flags="product.flags"/>
                        <v-responsive :aspect-ratio="1" class="position-relative" :class="{'border-b': useBikeTag}">
                            <v-img
                                contain
                                aspect-ratio="1"
                                :src="product.main_image?.url"
                                :alt="product.main_image?.alt"
                                class="bg-white"
                                width="100%"
                            >
                            </v-img>
                            <transition name="fade-transition" v-if="product.other_image">
                                <v-img
                                    :src="product.other_image?.url"
                                    :alt="product.other_image?.alt"
                                    class="image2 bg-white"
                                    width="100%"
                                    contain
                                    aspect-ratio="1"
                                    v-show="isHovering"
                                >
                                </v-img>
                            </transition>
                            <v-overlay
                                :model-value="isHovering"
                                contained
                                scroll-strategy="reposition"
                                scrim="#036358"
                                class="align-center justify-center hover-menu"
                                :class="{'is-hovering' : isHovering}"
                            >
                                <div class="d-flex flex-column justify-space-between h-100">
                                    <div class="buttons d-flex flex-column pr-3 pt-3 align-end">
                                        <div class="text-right buttons-button__wrap">
                                            <div
                                                class="c-pill rounded-circle position-relative d-inline-flex align-center pa-1"
                                                @click.prevent.stop="() => { hasModal ? openDialog(product.id) : emit('openDialog', product.id); overlayStore.setMenuOverlay(false); }">
                                                <v-icon size="x-small" :icon="mdiBinoculars" />
                                                <span class="text-caption c-pill--content">{{
                                                        $t('eshop::base-product.quick_look')
                                                    }}</span>
                                            </div>
                                        </div>
                                        <slot name="actions"></slot>
                                    </div>
                                    <div class="d-flex px-3 pb-3">
                                        <client-only>
                                            <v-tooltip location="top" open-on-click content-class="tooltip-top"
                                                       v-if="product.note">
                                                <template v-slot:activator="{ props }">
                                                    <v-icon
                                                        v-bind="props"
                                                        :icon="mdiInformationOutline"
                                                        color="orange"/>
                                                </template>
                                                <div class="text-body-2 text-black font-weight-bold">
                                                    {{ $t('eshop::base-product.note') }}
                                                </div>
                                                <div class="text-body-2 text-grey">{{ product.note }}</div>
                                            </v-tooltip>
                                        </client-only>
                                    </div>
                                </div>

                            </v-overlay>
                        </v-responsive>
                        <product-bike-tag v-if="useBikeTag" :product="product"></product-bike-tag>

                    </div>
                    <div class="d-flex flex-wrap align-center ga-2 mb-2">

                        <v-skeleton-loader type="list-item-two-line" width="150" class="ml-n4 my-n1"
                                           :loading="(actualProductVariant?.price === 'loading...' || product.price === 'loading...')">
                            <div class="pl-4 py-1 flex-1-1">
                                <price-hider big>
                                    <price-positioner>
                                        <template #with_vat="{ active }">
                                            <div
                                                :class="[active ? (modalSlider ? 'text-h6' : 'text-lg-h5 text-md-h6 text-body-1') : (modalSlider ? 'text-x-small' : 'text-lg-body-2 text-md-x-small text-x-tiny'), active ? 'font-italic font-weight-black' : 'font-italic text-grey', active && product.your_sale ?'text-red':'']"
                                                v-html="$t(active ? 'eshop::base-product.price' : 'eshop::base-product.price_with_vat', {price: actualProductVariant?.price || product.price})"
                                            >
                                            </div>
                                        </template>
                                        <template #without_vat="{ active }">
                                            <div
                                                :class="[active ? (modalSlider ? 'text-h6' : 'text-lg-h5 text-md-h6 text-body-1') : (modalSlider ? 'text-x-small' : 'text-lg-body-2 text-md-x-small text-x-tiny'), active ? 'font-italic font-weight-black' : 'font-italic text-grey', active && product.your_sale ?'text-red':'']"
                                                v-html="$t(active ? 'eshop::base-product.price' : 'eshop::base-product.price_no_vat', {price: actualProductVariant?.price_no_vat || product.price_no_vat})"
                                            >
                                            </div>
                                        </template>
                                    </price-positioner>
                                </price-hider>
                            </div>
                        </v-skeleton-loader>
                        <div class="text-right flex-1-1">
                            <availability-info-nibblet v-if="!product.state || product.state === 'active'" :availability="product.availability"
                                                       density="comfortable"></availability-info-nibblet>
                        </div>
                    </div>
                    <div class="d-flex ma-n1">
                        <div class="pa-1 flex-grow-1">
                            <quantity-changer
                                v-model="toAdd"
                                :stock="product.on_stock"
                                allow-no-stock
                                class="w-100"
                                @click.stop
                            ></quantity-changer>
                        </div>
                        <div class="pa-1">
                            <v-btn
                                :color="(product.state === 'active' || !product.state) ? 'green-lighten-1' : 'grey-darken-5'"
                                class="text-body-1 w-100 h-100"
                                :loading="loading"
                                elevation="0"
                                :disabled="!(product.state === 'active' || !product.state)"
                                @click.stop.prevent="addToOrder(product)"
                            >
                                <template #default>
                                    <span v-show="$vuetify.display.mdAndUp">{{
                                            $t(product.state === 'active' || !product.state ? 'eshop::base-product.add_to_cart' : 'eshop::base-product.not_available')
                                        }}</span>
                                    <v-icon :icon="mdiCartPlus" v-show="$vuetify.display.smAndDown"></v-icon>
                                </template>
                            </v-btn>
                        </div>
                    </div>
                    <v-row class="mx-n1 mb-n1 mt-4">
                        <v-col md="6" cols="12" class="pa-1">
                            <div
                                class="text-grey text-small"
                            >
                                <div v-if="$page.props.customer?.email" class="d-flex ga-2 mt-1">
                                    <span class="font-weight-bold text-no-wrap">{{ $t('eshop::base-product.retail_price') }}</span>
                                    <span class="d-flex flex-column">
                                        <span v-if="product.your_sale" class="font-italic text-decoration-line-through">{{product.price_no_discount_with_vat}}</span>
                                        <span :class="[product.your_sale?'text-red':'']">{{ product.moc_price }}</span>
                                    </span>
                                </div>
                                <div v-else>
                                    <span v-if="product.your_sale" class="font-italic text-decoration-line-through">
                                        {{ $t('eshop::base-product.price_with_vat', {price: product.price_no_discount_with_vat})}}
                                    </span>
                                </div>
                                <div v-if="product.note" class="d-flex ga-2 mt-1" style="max-width: 244px">
                                    <v-icon
                                        :icon="mdiInformationOutline"
                                        color="orange"
                                        style="font-size: inherit"
                                    />
                                    <div class="text-small text-grey">{{ product.note }}</div>
                                </div>
                            </div>
                        </v-col>
                        <v-col md="6" cols="12" class="pa-1">
                            <div
                                class="text-grey justify-md-end text-small text-right"
                            >
                                <span class="font-weight-bold text-no-wrap">{{
                                        $t('eshop::base-product.stock_number_truncated')
                                    }}</span> {{ product.stock_number }}
                            </div>
                        </v-col>
                    </v-row>
                </v-card-text>
            </v-card>
        </v-hover>
        <v-hover
            v-else-if="variant === 'list'"
            v-slot="{ isHovering, props }"
        >
            <v-card
                class="product-list rounded-0 px-4"
                elevation="0"
                :ripple="false"
                v-bind:class="cssClass"
                v-bind="props"
            >
                <tag :column="false" :floating="false" :flags="product.flags" class="mb-1"/>
                <div class="d-flex justify-space-between ga-2" v-if="$vuetify.display.smAndDown">

                    <div class="d-flex flex-column justify-center align-center flex-grow-0 ga-2">
                        <Link class="product-list-image" :href="product.url" :onStart="handleLink">
                            <v-responsive :aspect-ratio="1" class="position-relative">
                                <v-img
                                    :src="product.main_image?.url"
                                    :alt="product.main_image?.alt"
                                    width="140"
                                    class="bg-white"
                                    aspect-ratio="1"
                                    contain
                                >
                                </v-img>
                                <transition name="fade-transition" v-if="product.other_image">
                                    <v-img
                                        :src="product.other_image?.url"
                                        :alt="product.other_image?.alt"
                                        width="100%"
                                        class="image2 bg-white"
                                        aspect-ratio="1"
                                        v-show="isHovering"
                                        contain
                                    >
                                    </v-img>
                                </transition>
                            </v-responsive>
                        </Link>
                        <product-bike-tag :list-product="true" :product="product"></product-bike-tag>
                        <div class="d-flex align-center justify-end">
                            <v-btn size="x-small" variant="plain" class="to-warning"
                                   :prepend-icon="mdiBinoculars"
                                   @click.prevent.stop="() => { hasModal ? openDialog(product.id) : emit('openDialog', product.id); overlayStore.setMenuOverlay(false); }">
                                {{ $t('eshop::base-product.quick_look') }}
                            </v-btn>
                        </div>
                    </div>

                    <div class="d-flex flex-column ga-3 flex-grow-1">
                        <Link :href="actualProductVariant?.url || product.url" class="text-body-2 font-weight-bold"
                              :onStart="handleLink">
                            {{ product.name }}
                        </Link>

                        <div class="d-flex ga-2 justify-space-between">
                            <v-skeleton-loader class="mb-n2 bg-transparent"
                                               type="list-item-two-line"
                                               v-if="(
                                                       (actualProductVariant?.price === 'loading...' || product.price === 'loading...') ||
                                                       (actualProductVariant?.price_no_vat === 'loading...' || product.price_no_vat === 'loading...')
                                                       )">
                            </v-skeleton-loader>
                            <div v-else>
                                <price-hider>
                                    <price-positioner>
                                        <template #with_vat="{ active }">
                                            <div :class="[active ? 'text-body-2 font-italic font-weight-black' : 'text-body-2 font-italic text-grey', product.your_sale ?'text-red':'']"
                                                 v-html="$t(active ? 'eshop::base-product.price' : 'eshop::base-product.price_with_vat', {price: actualProductVariant?.price || product.price})">
                                            </div>
                                        </template>
                                        <template #without_vat="{ active }">
                                            <div :class="[active ? 'text-body-2 font-italic font-weight-black' : 'text-body-2 font-italic text-grey', product.your_sale ?'text-red':'']"
                                                 v-html="$t(active ? 'eshop::base-product.price' : 'eshop::base-product.price_no_vat', {price: actualProductVariant?.price_no_vat || product.price_no_vat})">
                                            </div>
                                        </template>
                                    </price-positioner>
                                </price-hider>
                            </div>
                            <availability-info-nibblet
                                :availability="actualProductVariant?.availability || product.availability"
                                density="comfortable"></availability-info-nibblet>
                        </div>

                        <div class="d-flex align-center justify-end ga-2 flex-wrap justify-center">
                            <quantity-changer
                                v-model="toAdd"
                                :stock="product.on_stock"
                                allow-no-stock
                                expanded
                                style="width: 124px"
                                small-text
                                @click.stop
                            ></quantity-changer>

                            <v-btn
                                color="green-lighten-1"
                                class="text-body-1 align-self-stretch h-auto addToBasketButton "
                                elevation="0"
                                :loading="loading"
                                @click.stop.prevent="addToOrder(product)"
                            >
                                <template #default>
                                    <v-icon :icon="mdiCartPlus"></v-icon>
                                </template>
                            </v-btn>
                        </div>

                        <v-divider></v-divider>

                        <div>
                            <div v-if="$page.props.customer?.email" class="text-body-2 text-grey d-flex ga-2">
                                <span class="font-weight-bold text-no-wrap">{{
                                    $t('eshop::base-product.retail_price')
                                }}</span>
                                <span v-if="product.your_sale" class="font-italic text-decoration-line-through d-block">{{product.price_no_discount_with_vat}}</span>
                                <span :class="product.your_sale?'text-red':''">{{ product.moc_price }}</span>
                            </div>
                            <div v-else class="text-body-2 text-grey d-flex ga-2">
                                <span v-if="product.your_sale" class="font-italic text-decoration-line-through">
                                    {{ $t('eshop::base-product.price_with_vat', {price: product.price_no_discount_with_vat})}}
                                </span>
                            </div>


                            <div class="text-body-2 text-grey d-flex ga-2 flex-wrap gr-0"><span
                                class="font-weight-bold text-no-wrap">{{
                                    $t('eshop::base-product.stock_number_truncated')
                                }}</span>{{
                                    product.stock_number
                                }}
                            </div>
                            <div v-if="product.note" class="d-flex ga-2" style="max-width: 244px">
                                <v-icon
                                    :icon="mdiInformationOutline"
                                    color="orange"
                                    style="font-size: inherit"
                                />
                                <div class="text-small text-grey">{{ product.note }}</div>
                            </div>
                        </div>
                    </div>

                </div>

                <div class="product-list-grid" v-if="$vuetify.display.mdAndUp">
                    <Link class="product-list-image" :href="product.url" :onStart="handleLink">
                        <v-responsive :aspect-ratio="1" class="position-relative" width="100px">
                            <v-img
                                :src="product.main_image?.url"
                                :alt="product.main_image?.alt"
                                width="100%"
                                class="bg-white"
                                aspect-ratio="1"
                                contain
                            >
                            </v-img>
                            <transition name="fade-transition" v-if="product.other_image">
                                <v-img
                                    :src="product.other_image?.url"
                                    :alt="product.other_image?.alt"
                                    width="100%"
                                    class="image2 bg-white"
                                    aspect-ratio="1"
                                    v-show="isHovering"
                                    contain
                                >
                                </v-img>
                            </transition>
                        </v-responsive>
                    </Link>
                    <div class="product-list-name">
                        <Link :href="actualProductVariant?.url || product.url" class="text-body-2 font-weight-bold"
                              :onStart="handleLink">
                            {{ product.name }}
                        </Link>
                        <div class="text-body-2 text-grey d-flex ga-2"><span
                            class="font-weight-bold text-no-wrap">{{ $t('eshop::base-product.stock_number_truncated') }}</span>{{
                                product.stock_number
                            }}
                        </div>
                        <product-bike-tag :list-product="true" :product="product"></product-bike-tag>
                        <div v-if="product.note" class="d-flex ga-2">
                            <v-icon
                                :icon="mdiInformationOutline"
                                color="orange"
                                style="font-size: inherit"
                            />
                            <div class="text-small text-grey">{{ product.note }}</div>
                        </div>
                    </div>
                    <div class="product-list-rest">
                        <div class="d-flex align-center gr-1 gc-4 product-list-rest__stock">
                            <div class="flex-grow-1">
                                <availability-info-nibblet
                                    :availability="actualProductVariant?.availability || product.availability"
                                    density="comfortable"></availability-info-nibblet>
                                <div class="d-flex align-center justify-end mr-n2">
                                    <v-btn size="x-small" variant="plain" class="to-warning"
                                           :prepend-icon="mdiBinoculars"
                                           @click.prevent.stop="() => { hasModal ? openDialog(product.id) : emit('openDialog', product.id); overlayStore.setMenuOverlay(false); }">
                                        {{ $t('eshop::base-product.quick_look') }}
                                    </v-btn>
                                </div>
                            </div>
                            <div class="text-right flex-grow-1">
                                <v-skeleton-loader class="mb-n2 bg-transparent"
                                                   type="list-item-two-line"
                                                   v-if="(
                                                       (actualProductVariant?.price === 'loading...' || product.price === 'loading...') ||
                                                       (actualProductVariant?.price_no_vat === 'loading...' || product.price_no_vat === 'loading...')
                                                       )">
                                </v-skeleton-loader>
                                <template
                                    v-else>
                                    <price-hider>
                                        <price-positioner>
                                            <template #with_vat="{ active }">
                                                <div v-if="active && product.your_sale" class="text-body-2 font-italic text-decoration-line-through">{{ product.price_no_discount_with_vat }}</div>
                                                <div :class="[active ? 'text-body-2 font-italic font-weight-black' : 'text-body-2 font-italic text-grey', product.your_sale ?'text-red':'']"
                                                     v-html="$t(active ? 'eshop::base-product.price' : 'eshop::base-product.price_with_vat', {price: actualProductVariant?.price || product.price})">
                                                </div>
                                            </template>
                                            <template #without_vat="{ active }">
                                                <div v-if="active && product.your_sale" class="text-body-2 font-italic text-decoration-line-through">{{ product.price_no_discount }}</div>
                                                <div :class="[active ? 'text-body-2 font-italic font-weight-black' : 'text-body-2 font-italic text-grey',  product.your_sale ?'text-red':'']"
                                                     v-html="$t(active ? 'eshop::base-product.price' : 'eshop::base-product.price_no_vat', {price: actualProductVariant?.price_no_vat || product.price_no_vat})">
                                                </div>
                                            </template>
                                        </price-positioner>
                                    </price-hider>
                                </template>
                            </div>
                        </div>
                        <div class="d-flex align-center ga-4 product-list-rest__cart">
                            <div>
                                <div v-if="$page.props.customer?.email" class="text-body-2 text-grey ga-2 text-right">
                                    <span class="font-weight-bold text-no-wrap d-block">{{
                                            $t('eshop::base-product.retail_price')
                                        }}</span>
                                    <span v-if="product.your_sale" class="font-italic text-decoration-line-through d-block">{{product.price_no_discount_with_vat}}</span>
                                    <span :class="product.your_sale?'text-red':''">{{ product.moc_price }}</span>
                                </div>
                            </div>
                            <div class="d-flex align-center justify-end ga-2">
                                <quantity-changer
                                    v-model="toAdd"
                                    :stock="product.on_stock"
                                    allow-no-stock
                                    style="min-width: 124px"
                                    small-text
                                    @click.stop
                                ></quantity-changer>

                                <v-btn
                                    color="green-lighten-1"
                                    class="text-body-1 align-self-stretch h-auto"
                                    elevation="0"
                                    :loading="loading"
                                    @click.stop.prevent="addToOrder(product)"
                                >
                                    <template #default>
                                        <v-icon :icon="mdiCartPlus"></v-icon>
                                    </template>
                                </v-btn>

                                <slot name="actionsTop"></slot>
                            </div>
                        </div>
                    </div>
                </div>
            </v-card>
        </v-hover>
    </div>
</template>

<script setup>
import {Link, router, usePage} from "@inertiajs/vue3";
import {computed, inject, nextTick, ref} from "vue";
import axios from "axios";
import Tag from "./Tag.vue"
import {mdiBinoculars, mdiCartPlus, mdiChevronLeft, mdiChevronRight, mdiClose, mdiInformationOutline} from '@mdi/js';
import {addEvent, generateItem} from "../../../../gtm";
import {useCartStore} from "../store/cart";
import pinia from "../../../../plugins/pinia";
import ClientOnly from "../../../../frontend/components/ClientOnly.vue";
import ProductBikeTag from "./ProductBikeTag.vue";
import QuantityChanger from "./QuantityChanger.vue";
import AvailabilityInfoNibblet from "./AvailabilityInfoNibblet.vue";
import PriceHider from "./PriceHider.vue";
import PricePositioner from "./PricePositioner.vue";
import Product from './Product.vue';
import {useOverlayStore} from "../../../../frontend/motonet/components/store/overlay.js";

const cartStore = useCartStore(pinia);

const props = defineProps({
    product: Object,
    actualProductVariant: Object,
    cssClass: [String, Array, Object],
    variant: {
        type: String,
        default: 'box',
    },
    catalog: {
        type: Boolean,
        default: true,
    },
    hasModal: {
        type: Boolean,
        default: true,
    },
    useBikeTag: {
        type: Boolean,
        default: true,
    },
    modalSlider: {
        type: Boolean,
        default: false,
    },
    navigation: {
        type: Object,
        default: null,
    },
    query: String
})

const emit = defineEmits(['changeIndex', 'openDialog'])

const route = inject('route');
const toAdd = ref(props.product.optimal_count_to_order);
const overlayStore = useOverlayStore();
const quickProduct = ref({});
const openDialog = (id) => {
    axios.post(route('product.ajax'), { id }).then((resp) => {
        quickProduct.value = resp.data;
        overlayStore.productDialog = id;
    });
};

const showDialog = computed({
    set: (val) => val ? overlayStore.productDialog = props.product.id : overlayStore.productDialog = null,
    get: () => overlayStore.productDialog === props.product.id
})

const loading = ref(false);
const addToOrder = (product, count) => {
    loading.value = true;
    // eslint-disable-next-line no-undef
    if (typeof count === "undefined") {
        count = toAdd.value;
    }
    const options = {
        id_product: product.id, count
    }
    if (props.actualProductVariant) {
        options.id_variant = props.actualProductVariant.id
    }

    axios.post(route('order.addProduct'), options).then((resp) => {
        usePage().props.flash = resp.data.flash;
        loading.value = false;
        if ('order' in resp.data) {
            usePage().props.order = resp.data.order;
            usePage().props.addToCart = {
                toBuy: resp.data.toBuy,
                order: resp.data.order
            };
            const item = cartStore.cartItems.find((item) => item.id_products == product.id);
            if (item) {
                const price = parseFloat(item.nice_price.replace(/\s/g, '').replace(/,/g, '.'));
                fireGaEvent(props.product, 'add_to_cart', {
                    currency: usePage().props.currency,
                    value: (price * count).toFixed(2)
                }, {quantity: count, price: price.toFixed(2)})
            }
        }

    })
}

const fireGaEvent = (product, event, attributes, itemAttributes = null) => {
    addEvent({
        event, ecommerce: {
            ...attributes,
            items: [
                generateItem(product, itemAttributes)
            ]
        }
    })
}

const handleLink = () => {
    if (usePage().props.group) {
        fireGaEvent(props.product, 'select_item', {
            item_list_id: usePage().props.group.id,
            item_list_name: usePage().props.group.name,
        })
    }
}

</script>

<style scoped lang="scss">
@use '../../../../plugins/vuetify-settings' as *;
@use 'vuetify/lib/styles/settings/variables' as *;
@use 'sass:map';

::v-deep(.addToBasketButton) {
    --v-input-control-height: 48px;
    height: var(--v-input-control-height) !important;
}

.product-name {
    display: -webkit-box;
    -webkit-line-clamp: 3;
    -webkit-box-orient: vertical;
    overflow: hidden;
    color: inherit;
}

.image2 {
    position: absolute;
    left: 0;
    right: 0;
    top: 0;
    bottom: 0;
    z-index: 1;
}

::v-deep(.hover-menu) {
    .v-overlay__content {
        width: 100%;
        height: 100%;
    }
}

.buttons {
    opacity: 0;
    transition: .3s ease-in-out;
    transition-property: box-shadow, transform, opacity, background, border-radius;
    transform: translate3d(-10%, 0, 0);
    gap: .3em;
}

.hover-menu {
    &.is-hovering {
        .buttons {
            opacity: 1;
            transform: translate3d(0, 0, 0);
        }
    }
}

.slide-up {
    transform: translate3d(0, 120%, 0);

    &.is-hovering {
        transform: translate3d(0, 0, 0);
    }
}

.z-100 {
    z-index: 10000000!important;
}

:deep(.v-img) img {
    position: absolute;
}

:deep(.product-card) {
    > .v-card-text {
        padding: 2rem 1.6rem;
        @media #{map.get($display-breakpoints, 'md-and-down')} {
            padding: $spacer * 5 $spacer * 3;
        }
    }

    .product-name {
        min-height: 45px;

        &:not(.modal-slider) {
            @media #{map.get($display-breakpoints, 'md-and-down')} {
                min-height: 36px;
            }
        }

        &.modal-slider {
            min-height: 40px;
        }
    }

    &:hover {
        > .v-card__overlay {
            opacity: 0;
        }
    }
}
</style>

<style lang="scss">
@use '../../../../plugins/vuetify-settings' as *;
@use 'vuetify/lib/styles/settings/variables' as *;
@use 'sass:map';
.c-pill--content {
    transition-property: transform, opacity, visibility;
    transition-duration: .35s;
    transition-timing-function: ease;
    position: absolute;
    background-color: rgb(var(--v-theme-cis-accent-color));
    height: 100%;
    right: 100%;
    display: inline-flex;
    align-items: center;
    justify-content: flex-end;
    padding-inline: .6em .2em;
    color: white;
    opacity: 0;
    visibility: hidden;
    white-space: nowrap;
    border-top-left-radius: 30px;
    border-bottom-left-radius: 30px;
    transform: translate3d(15px, 0, 0);
    z-index: -1;
}

.c-pill {
    transition-property: background-color, border-radius;
    transition-duration: .35s;
    transition-timing-function: ease;
    background-color: white;
}

.buttons-button__wrap {
    &:hover, &:focus, &:active {
        .c-pill {
            background-color: rgb(var(--v-theme-cis-accent-color));
            border-top-left-radius: 0 !important;
            border-bottom-left-radius: 0 !important;

            .v-icon {
                color: white;
            }
        }

        .c-pill--content {
            opacity: 1;
            visibility: visible;
            transform: translate3d(0, 0, 0);
        }
    }
}

.c-stock-line {
    @media #{map.get($display-breakpoints, 'md-and-up')} {
        line-height: 1.9;
    }
}

.c-stock-subline {
    &:not(.modal-slider) {
        line-height: 1.9;
        @media #{map.get($display-breakpoints, 'lg-and-up')} {
            line-height: 1.3;
        }
        @media #{map.get($display-breakpoints, 'md-and-up')} {
            line-height: 1.5;
        }
    }

    &.modal-slider {
        line-height: 1;
    }
}

.product-list-grid {
    display: grid;
    gap: .5rem;
    grid-template-columns: 100px minmax(auto, 254px) auto;
    align-items: center;
}

.product-list-rest {
    display: grid;
    gap: 1.4rem;
    grid-template-columns: 1fr auto;
    align-items: center;
}

.product-list-rest__stock {
    > :first-child {
        flex-basis: 40%;
    }

    > :last-child {
        flex-basis: 60%;
    }

    @media #{map.get($display-breakpoints, 'lg-and-down')} {
        flex-wrap: wrap;
        > * {
            flex-basis: 100%;
        }
    }
}

.product-list-rest__cart {
    @media #{map.get($display-breakpoints, 'md-and-down')} {
        flex-wrap: wrap;
        > div:first-child {
            text-align: right;

            > * {
                justify-content: flex-end;
            }
        }
        justify-content: flex-end;
        > * {
            flex-basis: 100%;
        }
    }
}

@media #{map.get($display-breakpoints, 'sm-and-down')} {
    .product-list-grid {
        grid-template-columns: 100px auto;
    }
    .product-list-rest {
        grid-column: 1/span 2;
    }
    .product-list-name {
        text-align: right;

        > * {
            justify-content: flex-end;
        }
    }
}
</style>
